import { createContext, ReactNode, useContext } from 'react'

export type DesignSystem = 'eui' | 'mui'

const DesignSystemContext = createContext<DesignSystem>( 'eui' )

export function useDesignSystem() {
	return useContext( DesignSystemContext )
}

export type DesignSystemProviderProps = {
	value: DesignSystem,
	children: ReactNode,
}

export function DesignSystemProvider( { value, children }: DesignSystemProviderProps ) {
	return (
		<DesignSystemContext.Provider value={value}>
			{children}
		</DesignSystemContext.Provider>
	)
}
